import { render, staticRenderFns } from "./wlnshop.vue?vue&type=template&id=dfe7afdc&scoped=true&"
import script from "./wlnshop.vue?vue&type=script&lang=js&"
export * from "./wlnshop.vue?vue&type=script&lang=js&"
import style0 from "./wlnshop.vue?vue&type=style&index=0&id=dfe7afdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe7afdc",
  null
  
)

export default component.exports